export default __webpack_public_path__ + "static/media/Company profile FCSI_ENG.0a2ef78c.pdf";